var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_vm._v(" The transaction failed because you have not registered for Shopin Tokenholder Voices yet. Go to "),_c('a',{attrs:{"href":"https://voice.blockwell.ai/shopin"}},[_vm._v("voice.blockwell.ai/shopin")]),_vm._v(" and follow the instructions to register. ")])
}]

export { render, staticRenderFns }